import { Box, Typography, useTheme } from "@mui/material";

interface ExitPollsBarGraphProps {
  title: string;
  total: number;
  totalLabel: string;
  data: {
    label: string;
    color: string;
    value: number;
  }[];
}

const ExitPollsBarGraph: React.FC<ExitPollsBarGraphProps> = ({ title, total, totalLabel, data }) => {
  const theme = useTheme();

  const dataPercentages = data.map(category => 
    category.value ? (category.value / total) * 100 : 0
  );

  return (
    <Box 
      sx={{ 
        width: '100%', 
        backgroundColor: 'background.paper', 
        boxShadow: theme.shadows[2], 
        borderRadius: 2, 
        p: 3,
        mt: 2 
      }}
    >
      <Typography variant="h6" component="h2" sx={{ textAlign: 'center', mb: 2 }}>
        {title}
      </Typography>

      {/* Bar Graph */}
      <Box 
        sx={{ 
          width: '100%', 
          display: 'flex', 
          flexDirection: 'column', 
          gap: 1,
          mb: 2
        }}
      >
        {data.map((category, index) => (
          <Box 
            key={category.label}
            sx={{ 
              width: '100%', 
              height: 30, 
              display: 'flex', 
              borderRadius: 0,
              overflow: 'hidden',
              backgroundColor: 'grey.200'
            }}
          >
            <Box 
              sx={{ 
                width: `${dataPercentages[index]}%`, 
                backgroundColor: category.color,
                height: '100%'
              }} 
            />
          </Box>
        ))}
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
        <Box sx={{ textAlign: 'center', flex: 1 }}>
          <Typography variant="body2">
            <Box component="span" sx={{ color: 'grey.200', mr: 0.5 }}>■</Box>
            {totalLabel}
          </Typography>
          <Typography variant="body2">
            {total.toLocaleString()}
          </Typography>
        </Box>        
        {data.map((category, index) => (
          <Box key={category.label} sx={{ textAlign: 'center', flex: 1 }}>
            <Typography variant="body2">
              <Box component="span" sx={{ color: category.color, mr: 0.5 }}>■</Box>
              {category.label}
            </Typography>
            <Typography variant="body2">
              {category.value.toLocaleString()} ({dataPercentages[index].toFixed(1)}%)
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default ExitPollsBarGraph;
